import React from "react"
import { IntlProvider } from "react-intl"

import en from "./en.json"
import fr from "./fr.json"


const LanguageProvider = ({ locale, children }) => {
  let messages = {}
  switch(locale) {
    case "fr":
      messages = fr
      break
    default:
      messages = en
  }

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale="en">
      {children}
    </IntlProvider>
  )
}

export default LanguageProvider